<template>
    <div class="h-10 w-10 flex items-center justify-center relative cursor-pointer" @click="toggle">
        <img src="/images/bear-helmet.svg" class="block bg-black/50 rounded-full p-1" />
        <div v-if="authenticated && newMessages" class="bg-red-700 text-red-100 leading-4 rounded-md text-xs px-1 absolute -top-1 -right-1 font-mono">
            {{ newMessages  }}
        </div>
    </div>
</template>

<script>
export default {
    name: 'NotificationButton',
    props: ['authenticated', 'newMessages'],
    methods: {
        toggle() {
            this.emitter.emit('notifications-toggle')
        }
    }
}
</script>
